// The one-line caption over a list painted from the phone's own copy when the edge could not be
// asked: honest about age without turning an older journal into an error.
import { useT } from "../lib/i18n";
import { Caption, Icon, Row } from "../ui";

export function CachedNote(): React.JSX.Element {
  const { t } = useT();
  return (
    <Row role="status" gap="2" marginBottom="2">
      <Icon name="cloud-off" size={14} tone="textFaint" />
      <Caption tone="faint">{t("common.state.cached")}</Caption>
    </Row>
  );
}
